import { lazy } from 'react';
import { TabListEntityTouchpoints } from 'src/compass/pages/riskManagement/TouchpointsPage';
import { TabListToRouteList } from '../../util/TabListToRouteList';
import { ICONS } from '../navigationIcons';

const NavigatorPage = lazy(() => import('src/compass/pages/riskManagement/NavigatorPage'));
const InventoryPage = lazy(() => import('src/compass/pages/riskManagement/InventoryPage'));
const FeederIndexPage = lazy(() => import('src/compass/pages/riskManagement/FeederIndexPage'));

const SceReportsPage = lazy(() => import('src/compass/pages/riskManagement/SceReportsPage'));
const TouchpointsPage = lazy(() => import('src/compass/pages/riskManagement/TouchpointsPage'));
const SalesDashboardPage = lazy(() => import('src/compass/pages/riskManagement/SalesDashboardPage'));
const MyDashboardPage = lazy(() => import('src/compass/pages/riskManagement/MyDashboardPage'));

export const RiskManagementMenu = [
  {
    menuTitle: 'Risk Management',
    path: 'riskmanagement',
    icon: ICONS.user,
    subMenus: [
      {
        title: 'My Dashboard',
        path: 'mydashboard',
        element: <MyDashboardPage />,
        permission: 'MY_COMMISSIONS',
      },
      {
        title: 'Touchpoints',
        path: 'touchpoints',
        element: <TouchpointsPage />,
        permission: 'ENTITY_TOUCHPOINTS',
        children: TabListToRouteList(TabListEntityTouchpoints),
      },
      {
        title: 'Feeder Index',
        path: 'feederindex',
        element: <FeederIndexPage />,
        permission: 'FEEDER_INDEX',
      },
      {
        title: 'Inventory',
        path: 'inventory',
        element: <InventoryPage />,
        permission: 'INVENTORY',
      },
      {
        title: 'Navigator',
        path: 'navigator',
        element: <NavigatorPage />,
        permission: 'NAVIGATOR',
      },
      {
        title: 'Sales Dashboard',
        path: 'salesdashboard',
        element: <SalesDashboardPage />,
        permission: 'SALES_DASHBOARD',
      },
      {
        title: 'SCE Reports',
        path: 'scereports',
        element: <SceReportsPage />,
        permission: 'SCE_REPORTS',
      },
    ],
  },
];
